import type { Route } from './Route';

declare global {
  interface Window {
      // constants from serverapi.js
      rvVer?: number;
      homeAPI?: string;
      tempestPlugin?: string; // "map_plugin"?
      userDisplayName?: string;
      nextgen?: number;
      rmsAPI?: string;
      API?: string;
      RDX?: string;
      WEB?: string;
      rvOnlineAPI?: string;
      RMS_WEB?: boolean;
      rvtaskAPI?: string;
      rvLanguage?: string;
  }
}

type RouteWithAPI = Route & {
  tempestapi?: string;
  rmsapi?: string;
  API?: string;
};

// global variables
let use_faults = true; // ZLP for additional GeoModel

const rvVer = window.rvVer;
if (rvVer < 8.2)
    use_faults = false;

const homeAPI = window.homeAPI;
let tempestAPI = ""; // define tempestAPI
let tempestGraphQLAPI = ""; // define tempest GraphQL API
let tempestToken = ""; // 2c196b2b-87ae-45d1-97b3-e412ce2d1149
const tempestPlugin = window.tempestPlugin;
const tempestServiceAPI = tempestPlugin ? "http://localhost:81/API/" : undefined; // TEMPEST service API
const userDisplayName = window.userDisplayName;
const nextgen = window.nextgen;
export let g_bDemo = false; // <!-- Not for DEMO
let rmsAPI = window.rmsAPI; // define rmsAPI
let API = window.API; // define API
let RDX = window.RDX; // define API RDX
let WEB = window.WEB; // define rv server API
const rvOnlineAPI = window.rvOnlineAPI;
let RMS_WEB = window.RMS_WEB;

const rvtaskAPI = window.rvtaskAPI;

const rvLanguage = window.rvLanguage as 'ru'|'en';

const DRAW_TRAJ_AS_LINES = 0;    // 1 - for DEBUG
const DRAW_PERF_AS_LINES = 0;    // 1 - for DEBUG
let ENABLE_PICKING_FRAMEBUFFER = 1; // 0 - disable picking, 1 - enable picking

const handleSize = 5; // in pixels (the actual size of the handle on screen would be this times 2)
const squareHandleSize = 5; // in pixels (the actual size of the handle on screen would be this times 2)
const squareSnapDistance = squareHandleSize * 3/*2*/;
const crossHandleSize = 5;
const crossSnapDistance = crossHandleSize * 3;
const perfEndHandleSize = 12; // in pixels (the actual size of the handle on screen would be this times 2)
const perfEndSnapDistance = perfEndHandleSize;

const wellTopLineHeight_pix = 25.0;

const pointRadius_px = 10;

const WELL_PLACE_ID = '74955043405';
const WELL_SUGGESTED_ID = '79099454405';

let clientID = "";
let sessionModelID = "";
let sessionID = "";

export const dash_short = " — "; // '\u2014' " &mdash; "
export const dash_long = "———";

const hostname = window.location.hostname
const bVW = /*hostname.includes('127.0.0.1') ||*/ hostname.includes('vego');

const g_appName = tempestPlugin === 'map_plugin' ? "Map Viewer" :
    (bVW? "Vego-Web": "ProPlast") // for MessageBoxes and so on

const daysInMonth = 30.4375; //  = 365.25 / 12

// chart
export const chartGridLinesWidth = 0.25;
export const chartGridLinesBorderDash = [8, 4];
export const chartTooltipsBackgroundColor = "#fcfcfc";
export const chartTooltipsTitleFontColor = "#3a3938";
export const chartTooltipsBodyFontColor = "#3a3938";
export const chartTooltipsBorderColor = "#3f4040";

const DataKeys = {
    Tracers: "_tracers.xml",
    TracersId: "_tracers\\_tracersId.xml",
    PPD: "_ppd.xml",
    ProdToinj: "_prodToinj_ppd.xml",
    CoefInfluence: "_coefInfluence.xml",
    CoefInfluenceForSpecifiedWells: "_coefInfluenceForSpecifiedWells.xml",
    DatabaseInfo: "_databaseInfo.xml",
    MapSettingsInfo: "_mapSettingsInfo.xml",
    GeoProject: "_geoProject.xml",
    OptimizationCache: "_optimizationCache.json",
    WellEditorCache: "_wellEditorCache.json",
    NoGoZoneSettingsCache: "_noGoZoneSettingsCache.xml",
    DBWells: "_DBWells.xml",
}

function generateUUID() { // Public Domain/MIT
    let d = Date.now();
    if (performance !== undefined && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.trunc((d + Math.random() * 16) % 16);
        d = Math.floor(d / 16);
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
}

const timeoutSessionAlive=1000*60; /*ms*/ // was : 1000*120
function keepClientAlive(url: string) {
  const xhr = new XMLHttpRequest;
  xhr.open("GET", url + "?_cache=" + Date.now(), true);
  xhr.setRequestHeader("apiClientID", clientID);
  xhr.send();
  //comm.send(API+'noop', 'check state ', 'text');
  //addAction(function() { comm.send(API+'noop', 'check state ', 'text') });
  window.setTimeout(keepClientAlive.bind(null, url), timeoutSessionAlive);
}

function getClientId(keepAlive: boolean) {
    //browserID = getCookie("browserID");
    //if (!browserID) browserID = "b_" + generateUUID();

    clientID = "w_" + generateUUID();
    if (keepAlive && !tempestAPI && API) {
      keepClientAlive(API+'noop');
    }
}

function setSessionModelID(idModel: string) {
    sessionModelID = idModel ? idModel: "";
}

function setSessionID(idSession: string) {
    sessionID = idSession ? idSession: "";
}

function setup_API(api: string, postfix: string) {
  let API = '';
  if (api.includes(':') || api.includes('.')) { // has hostname and port
    API = 'http://' + api;
  }
  else { // no hostname, port only
    if (window.location.protocol === 'file:') API = 'http://localhost:' + api;
    else API = 'http://' + hostname + ':' + api;
  }
  API += postfix;
  return API;
}
function parse_query_string(query: string) {
    if (query.startsWith('?'))
        query = query.substring(1) // cut strting '?'
    const vars = query.split("&");
    const query_string: Record<string, string | string[]> = {};
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        const key = decodeURIComponent(pair[0]);
        const value = decodeURIComponent(pair[1]);

        const query_param = query_string[key];

        // If first entry with this name
        if (typeof query_param === "undefined") {
            query_string[key] = /*decodeURIComponent*/(value);
            // If second entry with this name
        }
        else if (typeof query_param === "string") {
            const arr = [query_param, /*decodeURIComponent*/(value)];
            query_string[key] = arr;
            // If third or later entry with this name
        }
        else {
            query_param.push(decodeURIComponent(value));
        }
    }
    return query_string;
}
function get_url_param(key: string) {
    const urlParams = parse_query_string(window.location.search);
    const urlParam = urlParams[key];

    if (typeof urlParam === "string")
      return urlParam;
    else
      return urlParam[0];
}
function SetupAPIs(query: RouteWithAPI) : void {
  if (query && query.app) {
      if (query.app.startsWith("rv")) {
      RMS_WEB = false;
      if(query.app==="rv81")
        use_faults=true;
    }
    else if (query.app === "rms")
      RMS_WEB = true;
  }

  if (query && query.tempestapi) {
    tempestAPI = setup_API(query.tempestapi, '/api/v1/')
    tempestGraphQLAPI = setup_API(query.tempestapi, '/graphql/')
  }
  if (window.location.search) {
      console.log("window.location.search=" + window.location.search)
    /*if (tempestPlugin --tempestAPI)*/ {
      tempestToken = get_url_param("auth"); // .HTML is called by TEMPEST
    }
      if (tempestPlugin /* we are started from TEMPEST */) {
        tempestAPI = '/api/v1/'
        tempestGraphQLAPI = '/graphql/'
        // default port is 4223 !?
    }
  }

  if (!tempestAPI && query && query.rmsapi) {
    rmsAPI = setup_API(query.rmsapi, '/API/')
    API = rmsAPI;
  }
  if (!tempestAPI && !rmsAPI) {
    if (query && query.API) {
      API = setup_API(query.API, '/API/')
      // if (RMS_WEB) {
      //  rmsAPI = API;//"some string";
      // }
    }
    else if (window.location.protocol === 'file:') {
      API = 'http://127.0.0.1/API/';
    }
  }
  if (!tempestAPI && !rmsAPI && !API) {
    API="/pp/api/";
  }
  if (API && !WEB)
    WEB = API.replace("/pp/api/", "/pp/web/") // should be recieved from server
  if (API && !RDX)
      RDX = API.replace("/pp/api/", "pp/RDX") // should be recieved from server
  //if (API && !homeAPI)
    // synchronization API homeAPI = API.replace("/pp/api/", "/"); // should be recieved from server

  if (rmsAPI) {
    if (RMS_WEB === undefined)
      RMS_WEB = true; // ZLP default for server.py
  }

  //should be recieved from the server!!  rvOnlineAPI = API;
  //commented for test. should be turned by pp_home.ini  rvOnlineAPI = undefined; // for 7.2 Release

  /*
  console.log("RMS_WEB =", RMS_WEB) // application

  console.log("tempestPlugin =", tempestPlugin);
  console.log("tempestAPI =", tempestAPI);
  console.log("tempestGraphQLAPI =", tempestGraphQLAPI);
  console.log("tempestToken =", tempestToken);
  console.log("tempestServiceAPI =", tempestServiceAPI);
  console.log("userDisplayName =", userDisplayName);
  console.log("nextgen =", nextgen);
  console.log("rmsAPI =", rmsAPI);
  console.log("API =", API);
  console.log("RDX =", RDX);
  console.log("WEB =", WEB);

  console.log("rvOnlineAPI =", rvOnlineAPI);
  console.log("rvtaskAPI =", rvtaskAPI);
  */
}

function setupGlobals() {
  // force disable picking in Tempest
  if (tempestAPI) {
    ENABLE_PICKING_FRAMEBUFFER = 0;
  }
}

let isFileSaverSupported = false;
try {
    isFileSaverSupported = !!new Blob;
} catch (e) { console.warn(e); }

export {
    get_url_param,
    rvVer,
    homeAPI,
    tempestAPI, tempestGraphQLAPI, tempestToken, tempestPlugin, tempestServiceAPI,
    userDisplayName,
    nextgen,
    rmsAPI,
    API,
    RDX,
    WEB,
    RMS_WEB,
    rvOnlineAPI,
    rvtaskAPI,
    rvLanguage,
    isFileSaverSupported,
    DRAW_TRAJ_AS_LINES,
    DRAW_PERF_AS_LINES,
    ENABLE_PICKING_FRAMEBUFFER,
    handleSize,
    squareHandleSize,
    squareSnapDistance,
    crossHandleSize,
    crossSnapDistance,
    perfEndHandleSize,
    perfEndSnapDistance,
    clientID,
    sessionModelID,
    getClientId,
    setSessionModelID,
    sessionID,
    setSessionID,
    keepClientAlive,
    setup_API,
    SetupAPIs,
    setupGlobals,
    pointRadius_px,
    wellTopLineHeight_pix,
    WELL_PLACE_ID,
    WELL_SUGGESTED_ID,
    DataKeys,
    g_appName,
    use_faults,
    daysInMonth,
};
